import { faFile, faRankingStar } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RagDocumentReference } from '../../graphql/schema';
import FormattedMessage from '../base/FormattedMessage/formattedMessage';

interface Props {
  ragDocumentReferences?: RagDocumentReference[] | null;
}

const MessageRagDocumentReferences = ({ ragDocumentReferences }: Props) => {
  return (
    <div className="flex-col flex">
      <div className="p-5 space-y-5 flex-1 flex flex-col overflow-y-auto">
        {ragDocumentReferences?.map((ref) => (
          <a
            className="w-full space-y-1 block"
            key={ref.id}
            href={ref.url ?? ''}
            target="_blank"
          >
            <div className="flex flex-row space-x-4">
              {!!ref.relevance && (
                <div className="space-x-1 text-xs">
                  <FontAwesomeIcon icon={faRankingStar} size="sm" />
                  <span>Relevanz: {ref.relevance}</span>
                  {ref.fileId ? ', Quelle:' : ''}
                  {ref.fileId && (
                    <span>
                      "{ref.fileId.slice(ref.fileId.lastIndexOf('/') + 1)}"
                      {ref.pageNumber ? `, Seite ${ref.pageNumber}` : ''}
                    </span>
                  )}
                </div>
              )}
            </div>
            {(ref.title || ref.fileId) && (
              <div className="space-y-1">
                {ref.title && (
                  <div className="font-semibold text-gray-900">{ref.title}</div>
                )}
              </div>
            )}
            {ref.content && (
              <div className="*:!text-xs text-gray-500">
                <FormattedMessage text={ref.content} />
              </div>
            )}
            {ref.fileId && (
              <div className="text-xs">
                <br />
                <FontAwesomeIcon icon={faFile} size="sm" className="pr-1" />
                {ref.fileId.slice(ref.fileId.lastIndexOf('/') + 1)}
                {ref.pageNumber ? `, Seite ${ref.pageNumber}` : ''}
              </div>
            )}
            <hr />
          </a>
        ))}
      </div>
    </div>
  );
};

export default MessageRagDocumentReferences;
